import { useEffect } from 'react';
import * as Rx from 'rxjs';
import { Observable } from 'rxjs';
import { debounceTime, filter, map, take } from 'rxjs/operators';

export function useVisibleDelay({ visible, onVisible }: { visible?: boolean; onVisible: () => void }): void {
  useEffect(() => {
    if (!visible) {
      return;
    }

    const documentVisibleStream: Observable<boolean> = Rx.merge(
      Rx.of(!document.hidden),
      Rx.fromEvent(document, 'visibilitychange').pipe(map(() => !document.hidden))
    );

    const subscription = documentVisibleStream
      .pipe(
        debounceTime(3000),
        filter((visible) => visible === true),
        take(1)
      )
      .subscribe(() => {
        onVisible();
      });

    return (): void => {
      subscription.unsubscribe();
    };
  }, [visible, onVisible]);
}
